import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { InfoPanelGridCell } from '../info-panel-grid-cell';

@Component({
  selector: 'app-info-panel-link',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatProgressSpinnerModule],
  templateUrl: './info-panel-link.component.html',
  styleUrl: './info-panel-link.component.css',
})
export class InfoPanelLinkComponent extends InfoPanelGridCell {
  @Input() label?: string;
  @Input({ required: true }) text!: string;
  @Input() disabled = false;
  @Input() loading = false;
  @Input() href?: string;
  @Input() trailingIcon?: string;

  @Output() activated = new EventEmitter<void>();

  onClick(event: MouseEvent): void {
    if (this.disabled) return;
    if (this.href) event.preventDefault(); // let Angular router handle left-click; href is for right-click/new tab
    this.activated.emit();
  }
}
